import { render, staticRenderFns } from "./StorageProductsTable.vue?vue&type=template&id=8c4eaf5c&scoped=true&"
import script from "./StorageProductsTable.vue?vue&type=script&lang=js&"
export * from "./StorageProductsTable.vue?vue&type=script&lang=js&"
import style0 from "./StorageProductsTable.vue?vue&type=style&index=0&id=8c4eaf5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4eaf5c",
  null
  
)

export default component.exports